/* eslint-disable react-hooks/exhaustive-deps */
import { EffectCallback, useEffect } from 'react'

/**
 * Run's an effect on mount, and is cleaned up on unmount. Generally
 * useful for interop with non-react plugins or components
 *
 * ```ts
 *  useMountEffect(() => {
 *    const plugin = $.myPlugin(ref.current)
 *
 *    return () => {
 *      plugin.destroy()
 *    }
 *  })
 * ```
 * @param effect An effect to run on mount
 *
 *  @category effects - a function that runs on mount
 */
function useMountEffect(effect: EffectCallback) {
    return useEffect(effect, [])
}

export default useMountEffect
